import { Button, Checkbox, Field, Input, Link } from "@cvpartner/design-system";
import React from "react";
import { useId } from "react-aria";
import { ClientRouter } from "@/shared/ui/Link.tsx";
import { I18n } from "@/shared/util/translations.ts";
import { Form } from "./shared/Form.tsx";
import { CardContent } from "./shared/LoginCard.tsx";
import {
  CheckboxWrapper,
  LoginButtonWrapper,
  LoginLinkWrapper,
  Wrapper,
} from "./shared/Modern.tsx";

export interface Props {
  action?: string;
  allowExtendedLogin?: boolean;
  type: "normal" | "external" | "support";
  alert?: React.ReactNode;
  children?: React.ReactNode;
}

export const KeepMeSignedInCheckbox: React.FC = () => (
  <CheckboxWrapper>
    <Checkbox name="postpone_expiry_time" size="s">
      {I18n.t("signin.keep_me_signedin_checkbox")}
    </Checkbox>
  </CheckboxWrapper>
);

export const Login: React.FC<Props> = ({
  action = "/login",
  allowExtendedLogin = true,
  type,
  alert,
  children,
}) => {
  const emailId = useId();
  const passwordId = useId();
  const [isLoading, setIsLoading] = React.useState(false);

  return (
    <Wrapper
      heading={I18n.t(
        type === "external"
          ? "signin.header_title_external"
          : type === "support"
            ? "signin.header_title_admin_support"
            : "signin.header_title",
      )}
      subheading={
        type === "support" ? undefined : I18n.t("signin.header_subtitle")
      }
      rebrandInfo={type === "normal" || type === "external"}
      alert={alert}
    >
      {children}
      <Form
        action={action}
        onSubmit={() => {
          setIsLoading(true);
        }}
      >
        <CardContent>
          <div>
            <Field
              label={I18n.t(
                type === "external"
                  ? "signin.personal_email_label"
                  : type === "support"
                    ? "signin.label_email"
                    : "signin.work_email_label",
              )}
              name="epost"
            >
              <Input
                id={emailId}
                placeholder={I18n.t("signin.email_placeholder")}
                type="email"
                required={true}
                autoFocus={true}
              />
            </Field>
          </div>
          <div>
            <Field name="password" label={I18n.t("signin.password_label")}>
              <Input
                id={passwordId}
                placeholder={I18n.t("signin.password_placeholder")}
                type="password"
                required={true}
              />
            </Field>
          </div>
          {allowExtendedLogin && <KeepMeSignedInCheckbox />}
          <LoginButtonWrapper center={isLoading}>
            {isLoading ? (
              <Button
                type="submit"
                hierarchy="primary"
                variant="iconOnly"
                loading={true}
              />
            ) : (
              <Button type="submit" hierarchy="primary">
                {I18n.t("signin.signin_button")}
              </Button>
            )}
          </LoginButtonWrapper>
        </CardContent>
      </Form>
      <LoginLinkWrapper>
        <ClientRouter>
          <Link hierarchy="primary" href="/forgotpassword" size="s">
            {I18n.t("signin.forgot_password_link")}
          </Link>
        </ClientRouter>
      </LoginLinkWrapper>
    </Wrapper>
  );
};
